import { REP_METRICS } from '../componentKeys.js'

const identifiers = {
  key: 'payableHours',
  type: 'call',
  access: 'stats',
}

const formatting = {
  format: {
    title: 'Payable Hours',
  },
}

const keys = {
  statKey: 'payable_hours',
  componentKeys: [REP_METRICS],
  healthKey: 'metric_health',
}

const calculation = {
  calcType: 'aggregate',
  convertTo: 'hours',
}

const payableHours = {
  metaData: Object.assign(identifiers, formatting, keys, calculation),
  calculationConfig: calculation,
}

export { payableHours }
